import global from './common.js'
import api from '../service/api.js'
import { Message } from 'element-ui';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
let help = function() {};

/**
 * 获取当天的年月日
 * 如：2020-9-29
 */
help.prototype.currentDate = function() {
        let date = new Date()
        let y = date.getFullYear();
        let m = date.getMonth() + 1
        m = m < 10 ? '0' + m : m;
        let d = date.getDate();
        d = d < 10 ? '0' + d : d;
        let arr = new Array(y, m, d)
        date = arr.join('-');
        return date;
    }
    /**
     * 获取当天的年月日
     * 如：20200929
     */
help.prototype.currentDateTo = function() {
        let date = new Date()
        let y = date.getFullYear();
        let m = date.getMonth() + 1
        let d = date.getDate();
        let arr = new Array(y, m, d)
        date = arr.join('');
        return date;
    }
    /**
     * 保留两位小数
     * */
help.prototype.toDecimal = function(n) {
        if (typeof n == 'number') {
            if (n == 0) {
                return 0;
            } else {
                let price = Math.round(Math.floor(n * 1000) / 10) / 100
                return price;
            }
        }
    }
    /**
     * 两位小数 加.00
     * */
help.prototype.toDecimal2 = function(n) {
        let num = Number(n);
        if (num % 1 === 0) {
            num = num.toFixed(2)
        }
        return num;
    }
    
    /**
     * 日期格式化 例如 20201030
     * 2020-10-30
     * */
help.prototype.formatDate = function(date) {
        let result = '';
        if (date) {
            date = date.toString();
            let y = date.slice(0, 4);
            let m = date.slice(4, 6);
            let d = date.slice(6, 8);
            let arr = [y, m, d];
            result = arr.join('-')
        }
        return result;
    }
    
    /**
     * 时间格式化 例如 112025
     * 11:20:25
     */
    help.prototype.formatTime = function(time) {
        let result = '';
        
        if(time === '' || time  === null) return ''
        
        time = time.toString()
        if(time.length < 6){            
            let h = time.slice(0, 1);
            let m = time.slice(1, 3);
            let s = time.slice(3, 5);
            let arr = [h, m, s];
            result = arr.join(':');
        }else{
            let h = time.slice(0, 2);
            let m = time.slice(2, 4);
            let s = time.slice(4, 6);
            let arr = [h, m, s];
            result = arr.join(':');
        }
        return result;
    }
    /**
     * 验证是否为手机号码
     * @return boolean
     */
help.prototype.isMobile = function(number) {
    return (/^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/.test((+number))) && (number.toString().length == 11)
};
/**
 * 获取 年月日转换2020-09-23
 * */
help.prototype.getSelectDate = function(value) {
        if (value) {
            let y = value.getFullYear();
            let m = value.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            let d = value.getDate();
            d = d < 10 ? '0' + d : d;
            let date = [y, m, d].join('-');
            return date;
        }
    }
    /**
     * 根据毫秒 转换成 年月日时分秒
     * */
help.prototype.formatDuring = function(mss) {
    if (mss) {
        var days = parseInt(mss / (1000 * 60 * 60 * 24));
        var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = (mss % (1000 * 60)) / 1000;
        return days + " 天 " + hours + " 小时 " + minutes + " 分钟 " + seconds + " 秒 ";
    }
}
help.prototype.getImage = function(v) {
    if (v) {
        let url = global.baseImgURL + v;
        return url
    } else {
        return ''
    }
}
help.prototype.getIcon = function(v) {
        if (v) {
            let url = global.baseIconURL + v
            return url + '.jpg';
        } else {
            return '';
        }
    }
    /**
     * 年月日转换20200923 
     * */
help.prototype.getSelectDate2 = function(value) {
    if (value) {
        let y = value.getFullYear();
        let m = value.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        let d = value.getDate();
        d = d < 10 ? '0' + d : d;
        let date = [y, m, d].join('');
        return date;
    }
}
const getBase64 = function(file) {
    return new Promise(function(resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function() {
            imgResult = reader.result;
        };
        reader.onerror = function(error) {
            reject(error);
        };
        reader.onloadend = function() {
            resolve(imgResult);
        };
    });
}
// 上传图片，先转base64, 然后再上传
help.prototype.uploadRequest = function(file) {
    let formData = new FormData();
    formData.append("file", file.file);
    return new Promise((resolve, reject) => {
        getBase64(file.file).then(res => {
            let baseUrl = res.replace(/\+/g, "%2B")
            let params = {
                opcode: 1022,
                images: baseUrl
            }
            api._requestAPI(params).then(res => {
                if (res.IsSuccess) {
                    Message.success("上传图片成功")
                    resolve(res.Message)
                } else {
                    Message.error(res.Message)
                }
            }).catch(error => {
                Message.error('上传图片失败,请重新上传!')
                reject(error)
            })
        })
    })
}

// 上传图片多张，先转base64, 然后再上传
help.prototype.uploadMoreFileRequest = function(file) {
    let formData = new FormData();
    formData.append("file", file.file);
    return new Promise((resolve, reject) => {
        getBase64(file.file).then(res => {
            let baseUrl = res.replace(/\+/g, "%2B")
            let params = {
                opcode: 1022,
                images: baseUrl
            }
            api._requestAPI(params).then(res => {
                if (res.IsSuccess) {
                    const imageUrl = res.Message                   
                    // Message.success("上传图片成功")
                    resolve(imageUrl)
                } else {
                    Message.error(res.Message)
                }
            }).catch(error => {
                Message.error('上传图片失败,请重新上传!')
                reject(error)
            })
        })
    })
}
// 上传多张图片,先转base64,然后再上传
help.prototype.uploadMoreFileRequest2 = function(files,tempFilePaths) {
    let filesArray = []
    return new Promise((resolve, reject) => {
        // const tempFilePaths = files
        // let dataBase64 = getBase64(files.raw) 
        // console.log('2',dataBase64)
        // resolve(dataBase64)
        for(let i = 0; i < tempFilePaths.length;i++){
            // let filePath  = tempFilePaths[i]
            let dataBase64 = getBase64(files.file) 
            dataBase64 = dataBase64.replace(/\+/g, "%2B")
            console.log(dataBase64)
            let baseUrl = `data:image/png;base64,${dataBase64}`
            let params = {
              opcode: 1022,
              images: baseUrl
            }
            api._requestAPI(params).then(res=>{
              if(res.IsSuccess){
                const url = res.Message
                filesArray.push(url)
                if(filesArray.length === tempFilePaths.length){               
                  console.log(filesArray)                 
                  Message.success("上传图片成功")
                  resolve(filesArray)
                }           
              }else{
                // Message.error(res.Message)
                Message.error('上传图片失败,请重新上传!')
                reject(error)
              }
            })
          }
       
    })
}

// 传入一个base64的图片文件
help.prototype.uploadFile = function(file) {
    return new Promise((resolve, reject) => {
        let params = {
            opcode: 1022,
            images: file
        }
        api._requestAPI(params).then(res => {
            if (res.IsSuccess) {
                Message.success("上传图片成功")
                resolve(res.Message)
            } else {
                Message.error(res.Message)
            }
        }).catch(error => {
            Message.error('上传图片失败,请重新上传!')
            reject(error)
        })
    })
}
help.prototype.compressBase64Image = async function(base64, scale = 0.8) {
    let block = true;
    let that = this;
    return await compress(base64, scale);
    async function compress(base64, scale) {
        return new Promise(function(resolve, reject) {
            dealCompress(base64, scale);

            function dealCompress(base64, scale) {
                let _img = new Image();
                _img.src = base64;
                _img.onload = function() {
                    let _canvas = document.createElement("canvas");
                    let w = this.width * scale;
                    let h = this.height * scale;
                    _canvas.setAttribute("width", w);
                    _canvas.setAttribute("height", h);
                    _canvas.getContext("2d").drawImage(this, 0, 0, w, h);
                    let base64 = _canvas.toDataURL("image/jpeg");
                    let blob = that.base64ToFile(base64);
                    if (block) {
                        console.log('压缩一次之后大小：' + blob.size);
                        block = false;
                    }
                    if (blob.size > 1024 * 1024) {
                        dealCompress(base64, scale)
                    } else {
                        console.log('压缩结束大小：' + blob.size);
                        resolve(blob);
                    }
                }
            }
        });
    }
}


//img 为img对象，size 0-1之间
help.prototype.compressImage = async function(file, size) {
    var Orientation = await getOrientation(file);
    console.log('Orientation:', Orientation)
    return await targetDataUrl(file, size);

    async function targetDataUrl(f, ratio = 0.7) {
        ratio = 0.2;
        const promise = new Promise(function(resolve, reject) {
            var max_size = 1024 * 1024;
            var reader = new FileReader();
            var image = new Image;
            image.src = '';
            reader.onload = function() {
                image.src = this.result;
                image.onload = function() {
                    if (f.size > max_size) {
                        console.log('压缩前：', f.size / 1024 + 'KB');
                        //生成canvas
                        var canvas = document.createElement("canvas");
                        var ctx = canvas.getContext('2d');
                        var w = image.width,
                            h = image.height;
                        canvas.width = w;
                        canvas.height = h;
                        ctx.fillStyle = '#fff';
                        ctx.fillRect(0, 0, canvas.width, canvas.height)
                        ctx.drawImage(image, 0, 0); //, w, h, 0, 0, w, h
                        if (Orientation != "" && Orientation != 1 && Orientation != undefined) {
                            switch (Orientation) {
                                case 6: //需要顺时针90度旋转
                                    canvas.width = h;
                                    canvas.height = w;
                                    ctx.rotate(90 * Math.PI / 180);
                                    ctx.drawImage(this, 0, -h);
                                    break;
                                case 8: //需要逆时针90度旋转
                                    canvas.width = h;
                                    canvas.height = w;
                                    ctx.rotate(-90 * Math.PI / 180);
                                    ctx.drawImage(this, -w, 0);
                                    break;
                                case 3: //需要180度旋转
                                    ctx.rotate(180 * Math.PI / 180);
                                    ctx.drawImage(this, -w, -h);
                                    break;
                            }
                        }
                        let rd = canvas.toDataURL("image/jpeg", ratio);
                        console.log('压缩后：', rd.length / 1024 + 'KB')
                        resolve(rd);
                    } else {
                        console.log('未压缩')
                        resolve(image.src);
                    }
                }
            }
            reader.readAsDataURL(f);
        });
        return promise;
    }
}
// 取方括号内字符的正则
help.prototype.regexStr = function(str){
    let reg = ''
    const regex = /\[(.*?)\]/     
    if(str){
        const match = str.match(regex)
        reg = match[1]
    }
    return reg
}
// 页面全屏
help.prototype.enterFullScreen = function(){
    let element = document.documentElement;
    if (element.requestFullscreen) {
        element.requestFullscreen();
    } else if (element.mozRequestFullScreen) { /* Firefox */
        element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
        element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) { /* IE/Edge */
        element.msRequestFullscreen();
    }
}
// 页面退出全屏
help.prototype.exitFullScreen = function(){
    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen();
    }
}
help.prototype.isOneHourBefore = function(givenDateTimeStr, referenceDateTimeStr){  
    // 将字符串转换为Date对象  
    // 注意：这里假设日期格式是YYYY-MM-DD HH:MM:SS，且月份和日期都是两位数  
    const givenDateTime = new Date(givenDateTimeStr.replace(/-/g, '/'));  
    const referenceDateTime = new Date(referenceDateTimeStr.replace(/-/g, '/'));  
  
    // 计算参考时间点前一个小时的时间戳（到分钟级别）  
    // 注意：我们先去掉参考时间的秒和毫秒部分，然后再减去一个小时  
    const referenceMinutes = referenceDateTime.getMinutes();  
    const referenceSeconds = referenceDateTime.getSeconds();  
    const referenceMilliseconds = referenceDateTime.getMilliseconds();  
    referenceDateTime.setMinutes(referenceMinutes, 0, 0); // 设置分钟为原分钟，秒和毫秒为0  
    referenceDateTime.setHours(referenceDateTime.getHours() - 1); // 减去一个小时  
  
    // 为了确保比较的准确性，我们也去掉给定时间的秒和毫秒部分  
    const givenMinutes = givenDateTime.getMinutes();  
    const givenSeconds = givenDateTime.getSeconds();  
    const givenMilliseconds = givenDateTime.getMilliseconds();  
    givenDateTime.setMinutes(givenMinutes, 0, 0); // 设置分钟为原分钟，秒和毫秒为0  
  
    // 比较给定的日期时间是否位于参考时间点前一个小时的范围内（到分钟级别）  
    // 注意：这里我们使用了getTime()来获取时间戳，但实际上由于我们已经将秒和毫秒部分设为0，  
    // 所以直接使用大于小于比较也是可以的，但为了清晰起见，我们还是保留了getTime()的调用  
    return givenDateTime.getTime() >= referenceDateTime.getTime() &&   
           givenDateTime.getTime() < (referenceDateTime.getTime() + 60 * 60 * 1000);  
}
/**
 * 输入小于8位的正整数
 * */ 
help.prototype.checkNumber = function(v, maxPointLength = 0) {
    let err = '';
    if (maxPointLength == 0) {
        if (!/^\d{1,8}$/.test(v)) {
            err = '请输入小于8位的正整数';
        }
        let prefixO = v.toString().substring(0, 1) == '0';
        if (prefixO && v != '0') {
            err = '请输入小于8位的正整数'
        }
    } else {
        err = this.checkPointLength(v, maxPointLength);
    }
    return err;
}
/**
 * 输入数值型 几位小数
 * */ 
help.prototype.checkPointLength = function(v, maxPointLength = 2) {
    let err = ''
    if (isNaN(v)) {
        err = '数值格式错误';
    } else {
        v = v.toString();
        if (v.indexOf('.') > -1) {
            let num = v.split('.')[1];
            if (isNaN(num)) {
                err = '数值格式错误';
            } else {
                err = (num.length > maxPointLength) ? '小数点位数错误！' : '';
            }
        }
    }
    return err;
};
/**
 * 输入金额 限制只能输入两位小数
 */
help.prototype.numberToPrice = function(value) {
    if (value < 0 || value.charAt(0) == '.') {
        value = '';
    }
    value = value.match(/^\d*(\.?\d{0,2})/g)[0];
    return value;
}
/**
 * 输入折扣 限制只能输入正整数
 */
help.prototype.numberToPercent = function(value) {
    // if (value < 0 || value.charAt(0) == '.') {
    //     value = 1;
    // }
    value = value.replace(/\D/g,'');
    return value;
}
/**
 * 校验姓名是否为 2 到 4 个汉字
 * */ 
help.prototype.validateName =  function(name){
     // 正则表达式：匹配 2 到 4 个汉字
     const regex = /^[\u4e00-\u9fa5]{2,4}$/;
     return regex.test(name);
}
/**
 * 校验身份证号 15 或 18 位
 * */ 
help.prototype.validateIdCardLength =  function(idCard) {
    // 去掉字符串两端的空格
    idCard = idCard.trim();
   
    // 检查长度是否为 18
    if (idCard.length === 18) {
      return true;
    } else {
      return false;
    }
}

/**
 * 成绩查询的标题 返回一个表头数组 成绩查询
 * */ 
help.prototype.transformObjectToArray = function(obj) {
    const result = [];
    const mapping = {
        '名次': 'rank',
        '单位': 'company',
        '选手': 'username',
        '搭档': 'partnerName',                
        '胜轮次': 'winNum',
        '级差总分': 'totalRank',
        '积分': 'score',
        '升级数': 'number',
        '对手总分': 'totalPlayers',
        '对手总级差分': 'totalMinusPlayers',
        '搭档总分': 'partnerScore',
        '搭档总级差分': 'partnerRank'
    };        
    for (let key in obj) {
        if (obj.hasOwnProperty(key) && mapping.hasOwnProperty(key)) {                  
            result.push({
                label: key,
                prop: mapping[key]
            });
        }
    }        
    return result;
}
/**
 * 成绩查询的标题 返回一个表头数组 总表
 * */ 
help.prototype.transformObjectToArrayTotal = function(obj) {
    const result = [];
    const mapping = {               
        '胜轮次': 'winNum',
        '级差总分': 'totalRank',
        '积分': 'score',
        '升级数': 'number',
        '对手总分': 'totalPlayers',
        '对手总级差分': 'totalMinusPlayers',
        '搭档总分': 'partnerScore',
        '搭档总级差分': 'partnerRank'
    };        
    for (let key in obj) {
        if (obj.hasOwnProperty(key) && mapping.hasOwnProperty(key)) {                  
            result.push({
                label: key,
                prop: mapping[key]
            });
        }
    }        
    return result;
}
/**
 * 导出excel
 * */ 
help.prototype.ExportFormData =  function(data,name){
    // 假设有一个表格数据的数组
    // console.log(this.exportData)
    // aoa_to_sheet array
    // const data = [
    //     ["选手编号","选手姓名", "搭档姓名", "选手手机号","搭档手机号","协会（俱乐部）"],
    //     []
    // ];

    // 将数据转换为工作表
    const worksheet = XLSX.utils.json_to_sheet(data);

    // 创建工作簿并添加工作表
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // 生成Excel文件
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // 使用blob和FileReader创建一个Blob URL   type: application/octet-stream
    const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const blobUrl = window.URL.createObjectURL(dataBlob);

    // 使用saveAs下载文件
    saveAs(dataBlob, name +''+'.xlsx');

    // 清理
    window.URL.revokeObjectURL(blobUrl);
}
/**
 * 替换图片链接
 * */ 
help.prototype.replaceHttpWithHttps = function(imageUrl) {
    if (imageUrl.includes('http://139.196.214.81:8082')) {
      return imageUrl.replaceAll('http://139.196.214.81:8082', 'https://www.guanyb.cn');
    }
    return imageUrl; // 如果不是 HTTP 链接，直接返回原链接
}
help.prototype.copyText = function(txt){
    var input = document.createElement("input"); // 创建input对象
    input.value = txt; // 设置复制内容
    document.body.appendChild(input); // 添加临时实例
    input.select(); // 选择实例内容
    document.execCommand("Copy"); // 执行复制
    document.body.removeChild(input); // 删除临时实例    
    return input.value
}
// 生成级牌
help.prototype.generateCardArray = function(start, end){
    const cardValues = {  
      '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9, '10': 10,  
      'J': 11, 'Q': 12, 'K': 13  ,'A': 14
    };  
  
    const valueToCard = {  
      11: 'J', 12: 'Q', 13: 'K' , 14: 'A' 
    };    
    const startValue = cardValues[start];  
    const endValue = cardValues[end];  
  
    if (startValue === undefined || endValue === undefined) {  
      throw new Error('Invalid card face');  
    }    
    const values = [];  
    for (let i = startValue; i <= endValue; i++) {  
      values.push(i);  
    }    
    const cards = values.map(value => {  
      if (value <= 10) {  
          return value.toString();  
      } else {  
          return valueToCard[value];  
      }  
    });    
    return cards;  
}
export default new help;


// WEBPACK FOOTER //
// ./src/utils/help.js